import React from "react";
import TicketVolumeChart from "./TicketVolumeChart";

interface IProps {
  data?: any;
  startDate?: string;
  endDate?: string;
  teamId?: string | null;
  workflowId?: string | null;
}

const TicketVolume: React.FC<IProps> = ({
  data: volumeData,
  startDate,
  endDate,
  teamId,
  workflowId,
}) => {
  return (
    <div className="card">
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="fs-2 fw-bold text-gray-800 me-2 lh-1 ls-n2">
            Total volume
          </span>
        </h3>
      </div>

      <TicketVolumeChart
        intervalData={volumeData}
        startDate={startDate}
        endDate={endDate}
        teamId={teamId}
        workflowId={workflowId}
      />
    </div>
  );
};

export default TicketVolume;